import { render, staticRenderFns } from "./CheckEmailDeliverModal.vue?vue&type=template&id=488d8715&"
import script from "./CheckEmailDeliverModal.vue?vue&type=script&lang=js&"
export * from "./CheckEmailDeliverModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports